<script>

import axios from 'axios';

export default class PlanosRepository{
    
    async getPlanos(token,page,rawdata){
        
        const baseURL = page
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const data = rawdata;
        const response = await axios.post(baseURL, data,{headers:headers});
        return response;

    }

    async createPlano(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deletePlano(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getPlano(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  updatePlano(page,token,id,rawdata) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.put(baseURL,data,{ headers });
        return response;
       
    }

}
</script>
